/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
import { Component, Input, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';
@Component({
  selector: 'buttons-grid',
  templateUrl: './buttons-grid.component.html',
  styleUrls: ['./buttons-grid.component.scss'],
})
export class ButtonsGridComponent implements OnInit {
  @Input() buttonList: any[];
  @Input() title: string;
  @Input() truncateAt: number;
  public imgs: object = {};
  public showMore: boolean;
  public buttonListArray: any[];
  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.buttonList.forEach((item) => {
      this.pload(item.title, item.carousel_img);
    });
    this.showMore = !!this.truncateAt;
    this.updateButtonList();
  }

  updateButtonList() {
    this.buttonListArray = this.showMore
      ? this.buttonList.slice(0, this.truncateAt)
      : this.buttonList;
  }
  onShowMore() {
    this.showMore = !this.showMore;
    this.updateButtonList();
    this.analyticsService.trackUnified('button_grid_toggle_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_grid_clicked',
      component: 'button-grid-component',
      button: 'see more/see less',
    });
  }
  // navigateTo(item){
  //   if(item.lan)
  // }
  pload(element, imgUrl): void {
    this.imgs[element] = new Image();
    this.imgs[element].src = imgUrl;
  }
  handleGridButtonAction(buttotName: string) {
    this.analyticsService.trackUnified('button_grid_clicked', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_grid_clicked',
      component: 'button-grid-component',
      button: buttotName,
    });
  }
}
